import React from 'react';
import { connect } from 'react-redux';
import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';
import { breakpoints } from './../../styles/theme.json';

const FooterLayout = (props) => {
  return (
    <footer id={'footer-layout'}>
      {
        (props.window_width >= breakpoints.desktop)
        ? <DesktopFooter socialLinks={props.socialLinks}/>
        : <MobileFooter socialLinks={props.socialLinks}/>
      }
      <style jsx>{`
        #footer-layout {
          position: relative;
          width: 100vw;
          display: flex;
          justify-content: center;
          margin-top: 1.5rem;
        }
        @media (min-width: 640px) {
          #footer-layout {
            margin-top: 0;
          }
        }
      `}</style>
    </footer>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(FooterLayout);



// WEBPACK FOOTER //
// ./src/components/footer/FooterLayout.js